// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Pages
import { AlteracaoSenhaPage } from '@app/pages/alteracao-senha/alteracao-senha.page';
import { CadastroUsuarioPage } from '@app/pages/cadastro-usuario/cadastro-usuario.page';
import { CurriculoPage } from '@app/pages/curriculo/curriculo.page';
import { InscricaoPage } from '@app/pages/inscricao/inscricao.page';
import { LoginPage } from '@app/pages/login/login.page';
import { PaginaNaoEncontradaPage } from '@app/pages/pagina-nao-encontrada/pagina-nao-encontrada.page';
import { RecuperacaoSenhaPage } from '@app/pages/recuperacao-senha/recuperacao-senha.page';
import { SubstituicaoEmailPage } from '@app/pages/substituicao-email/substituicao-email-page';
import { VagaDetalhesPage } from '@app/pages/vaga-detalhes/vaga-detalhes.page';
import { VagaListaPage } from '@app/pages/vaga-lista/vaga-lista.page';
import { VagaParticiparEntrevistaPage } from './pages/vaga-participar-entrevista/vaga-participar-entrevista.page';
import { AvisoPrivacidadePage } from './pages/aviso-privacidade/aviso-privacidade.page';

// Guards
import { AutenticacaoGuard } from '@app/guards/autenticacao.guard';
import { VerificacaoNovaSenhaGuard } from '@app/guards/verificacao-nova-senha.guard';
import { TermoLgpdComponent } from './pages/termo-lgpd/termo-lgpd.component';
import { EditarDadosPage } from '@app/pages/editar-dados/editar-dados.page';
import { FazerRedacaoPage } from './pages/fazer-redacao/fazer-redacao.page';


const routes: Routes = [
  { path: 'alteracao-senha', component: AlteracaoSenhaPage, canActivate: [AutenticacaoGuard] },
  { path: 'cadastro-usuario', component: CadastroUsuarioPage },
  // {
  //   path: 'candidato', canActivate: [AutenticacaoGuard, VerificacaoNovaSenhaGuard], children: [
  //     { path: 'curriculo', component: CurriculoPage },
  //     { path: 'inscricao', component: InscricaoPage },
  //     { path: 'editar-dados', component: EditarDadosPage },
  //     { path: 'fazer-redacao', component: FazerRedacaoPage },
  //   ]
  // },
  {
    path: 'candidato', canActivate: [AutenticacaoGuard], children: [
      { path: 'curriculo', component: CurriculoPage, canActivate: [VerificacaoNovaSenhaGuard] },
      { path: 'inscricao', component: InscricaoPage, canActivate: [VerificacaoNovaSenhaGuard] },
      { path: 'editar-dados', component: EditarDadosPage, canActivate: [VerificacaoNovaSenhaGuard] },
      { path: 'fazer-redacao', component: FazerRedacaoPage },
    ]
  },
  { path: 'login', component: LoginPage },
  { path: 'recuperacao-senha', component: RecuperacaoSenhaPage },
  { path: 'substituicao-email', component: SubstituicaoEmailPage },
  {
    path: 'vagas', canActivate: [AutenticacaoGuard, VerificacaoNovaSenhaGuard], children: [
      { path: 'detalhes/:idVaga', component: VagaDetalhesPage },
      { path: 'lista', component: VagaListaPage },
      { path: 'lista', component: VagaListaPage },
      { path: 'participar-entrevista/:idEntrevistaVaga', component: VagaParticiparEntrevistaPage },
    ]
  },
  { path: 'termoUsuario', component: TermoLgpdComponent, canActivate: [AutenticacaoGuard, VerificacaoNovaSenhaGuard] },
  { path: '', redirectTo: '/vagas/lista', pathMatch: 'full' },
  { path: 'avisoPrivacidade', component: AvisoPrivacidadePage },
  { path: '**', component: PaginaNaoEncontradaPage }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
